import { SettingComponent } from "../../components";

export default function CommonSettingPage() {
  return <SettingComponent.CommonSettingPage />;
}
